import { render, staticRenderFns } from "./tiers.vue?vue&type=template&id=7f876de0&"
import script from "./tiers.vue?vue&type=script&lang=js&"
export * from "./tiers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../DATA/projects/nguonhangchina/admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports